var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBanRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-ban-red",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.375000, 0.375000)",
    fill: "#DC3545",
    fillRule: "nonzero",
    id: "\\uF05E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.375,3.421875 C5.65625,1.140625 8.40625,0 11.625,0 C14.84375,0 17.5859375,1.1328125 19.8515625,3.3984375 C22.1171875,5.6640625 23.25,8.40625 23.25,11.625 C23.25,14.84375 22.1171875,17.5859375 19.8515625,19.8515625 C17.5859375,22.1171875 14.84375,23.25 11.625,23.25 C8.40625,23.25 5.6640625,22.1171875 3.3984375,19.8515625 C1.1328125,17.5859375 0,14.84375 0,11.625 C0,8.40625 1.125,5.671875 3.375,3.421875 Z M1.5,11.953125 C1.59375,14.609375 2.5859375,16.8828125 4.4765625,18.7734375 C6.3671875,20.6640625 8.640625,21.65625 11.296875,21.75 C13.953125,21.84375 16.265625,21.03125 18.234375,19.3125 L3.9375,5.015625 C2.21875,6.984375 1.40625,9.296875 1.5,11.953125 Z M19.3125,18.234375 C21.03125,16.265625 21.84375,13.953125 21.75,11.296875 C21.65625,8.640625 20.6640625,6.3671875 18.7734375,4.4765625 C16.8828125,2.5859375 14.609375,1.59375 11.953125,1.5 C9.296875,1.40625 6.984375,2.21875 5.015625,3.9375 L19.3125,18.234375 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBanRed);
export default __webpack_public_path__ + "static/media/icon-ban-red.1cb2070a60a42abdc0efa30bedea1c1e.svg";
export { ForwardRef as ReactComponent };